import React from "react";
import { useTranslation } from "react-i18next";

export default function BuyNowGuidanceModal({ open, onClose, onMakeOffer }) {
  const { t } = useTranslation(["inbox", "common"]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center px-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/50"
        aria-label={t("common:close", "Close")}
        onClick={onClose}
      />

      <div className="relative w-full max-w-md rounded-2xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 shadow-2xl p-5">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          {t("inbox:buyNowGuidanceTitle", "Buy now is being improved")}
        </h3>

        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
          {t(
            "inbox:buyNowGuidanceMessage",
            "We are currently adding secure payment and delivery options. For now, you can negotiate directly with the seller."
          )}
        </p>

        <div className="mt-5 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={() => {
              onClose?.();
              onMakeOffer?.();
            }}
            className="px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium"
          >
            {t("inbox:makeOffer", "Make an offer")}
          </button>

          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-300 dark:border-neutral-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-neutral-800 text-sm font-medium"
          >
            {t("common:close", "Close")}
          </button>
        </div>
      </div>
    </div>
  );
}
